import React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";
import { ProductConfigurator } from "components/ProductConfigurator/ProductConfigurator";
import type { ObjValidatorProps } from "interfaces/shared.types";

export const ProductConfiguratorComponent = Scrivito.connect(() => {
  return <ProductConfigurator />;
});

const CheckedPage = (props: ObjValidatorProps) => {
  const { page } = props;

  if (!page) {
    return <ProductConfiguratorComponent />;
  }

  return (
    <ObjValidator page={page}>
      <ProductConfiguratorComponent />
    </ObjValidator>
  );
};
export default CheckedPage;
Scrivito.provideComponent("ProductConfigurator", CheckedPage);
